import styled from 'styled-components';

import { MedicalServiceWithPractitionersSimple } from '@dreryk/egabinet-private-medical-service-frontend-api';
import { Money } from '@dreryk/money-common-api';

import {
   createDynamicColumnsWidth,
   JustifyContent,
   RowDetails,
   RowDetailsCell,
   StyledFlex,
   Text,
} from '@dreryk/react-components';

import { PriceText } from '../../../shared/components/PriceText';
import { SpecialtiesText } from '../../../shared/specialties/SpecialtiesText';

import { PractitionerMedicalServiceOptionsCell } from './PractitionerMedicalServiceOptionsCell';

const StyledPractitionerRowDetails = styled(RowDetails)`
   padding-left: 60px;
   padding-right: 50px;
`;

StyledPractitionerRowDetails.displayName = 'StyledPractitionerRowDetails';

type PractitionerRowDetailsProps = {
   readonly defaultPrice: Money;
   readonly individualPrice: Money | undefined;
   readonly practitionerName: string;
   readonly practitionerSpecialtyNames: string[];
   readonly practitionerMedicalServiceId: number;
   readonly practitionerId: number;
   readonly hasMorePractitioners: boolean;
   readonly medicalService: MedicalServiceWithPractitionersSimple;
};

export const PractitionerRowDetails = (props: PractitionerRowDetailsProps): JSX.Element => {
   const columnsWidth = createDynamicColumnsWidth({
      nameWithSpecialties: '100%',
      price: '110px',
      empty: '90px',
      options: '64px',
   });

   return (
      <StyledPractitionerRowDetails testId={`practitioner-${props.practitionerId}`}>
         <RowDetailsCell testId={'nameWithSpecialties'} width={columnsWidth.nameWithSpecialties}>
            <StyledFlex direction={'column'}>
               <Text testId={'displayName'}>{props.practitionerName}</Text>
               <SpecialtiesText specialties={props.practitionerSpecialtyNames} compact secondary />
            </StyledFlex>
         </RowDetailsCell>
         <RowDetailsCell testId={'price'} width={columnsWidth.price} justifyContent={JustifyContent.END}>
            <PriceText testId={'price'} value={props.individualPrice ?? props.defaultPrice} />
         </RowDetailsCell>
         <RowDetailsCell testId={'empty'} width={columnsWidth.empty}>
            {''}
         </RowDetailsCell>
         <RowDetailsCell testId={'options'} width={columnsWidth.options}>
            <PractitionerMedicalServiceOptionsCell
               practitionerId={props.practitionerId}
               medicalService={props.medicalService}
               practitionerName={props.practitionerName}
               practitionerMedicalServiceId={props.practitionerMedicalServiceId}
               hasMorePractitioners={props.hasMorePractitioners}
            />
         </RowDetailsCell>
      </StyledPractitionerRowDetails>
   );
};
